export class PassengerChangeTimeVectorStepsData
{
    id:number;
    luggageCategoryId:number;
    factorSetStepsId:number;
    value:number;
    timeTypeId:number;
}